

 export const GlobalName:any ={
    tokenName:"afrilinkToken",
    refreshTokenName:"afrilinkRefreshToken",
    userName:"afrilinkUserConnected",
    exercice:"afrilinkExercise",
    expireIn:'afrilinkExpireIn',
    features:'afrilinkFeatures'
 }
